import _ from "underscore";
import { ExpandableItem } from "./ExpandableItem";
import DriveView from "../../../DriveView";
import { handleApi } from "../../../utils/error";
import { ExpandableItemView } from "./expandableItemView";
import AppView from "../../../app.view";
import html from "./expandableList.tmpl";

interface IExpandableListOptions extends Backbone.ViewOptions<ExpandableItem> {
    items: ExpandableItem[];
    app: AppView;
}

export class ExpandableList extends DriveView<ExpandableItem> {
    private readonly items: ExpandableItem[];
    private readonly template  = _.template(html);

    constructor(options: IExpandableListOptions) {
        super(options);
        this.items = options.items;
        this.app = options.app;
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click .expandableList__item": this.toggleItem
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    toggleItem(e: Event) {
        let id = (e.currentTarget as HTMLElement).getAttribute("data-id");
        let item: ExpandableItem = this.items.filter(i => i.id === id)[0];
        item.toggle();
    }

    render() {
        this.display(this.template()).then(() => {
            let container = document.createDocumentFragment();
            this.items.forEach(item => this.renderItem(item, container));
            this.el.querySelector(".expandableList").appendChild(container);
        }).catch(handleApi);
        return this;
    }

    renderItem(item: ExpandableItem, container: HTMLElement | DocumentFragment) {
        let itemView = new ExpandableItemView({app: this.app, tagName: "li", model: item });
        container.appendChild(itemView.render().el);
    }
}